<template>
  <StepTitle>
    <div v-if="!isEnhancedContent" v-html="activeSession && activeSession.label" class="how-can label-content-width"></div>
    <template v-if="!isEnhancedContent && activeSession && activeSession.subtitle" #subtitle>
      <div v-html="activeSession.subtitle"  class="option"></div>
    </template>
    <template v-if="activeSession && activeSession.content && activeSession.content.length" #content>
      <b-row class="justify-content-center">
        <b-col :class="{'col-md-10 col-lg-8 col-xl-6': !isEnhancedContent}"
          v-html="activeSession.content">
        </b-col>
      </b-row>
    </template>
  </StepTitle>
</template>

<script>
import { mapState } from 'vuex'
import StepTitle from './StepTitle'

export default {
  name: 'SessionContent',
  components: {StepTitle},
  computed: {
    ...mapState(['session', 'popupSession']),
    isEnhancedContent: function() {
      return this.activeSession && !!this.activeSession['enhanced_mode']
    },
    activeSession() {
      return this.session && this.session.is_popup && this.popupSession ? this.popupSession : this.session
    }
  }
}
</script>
<style scoped>
</style>
